import {
  ContextVariable,
  DynamicListOption,
} from 'src/types/actionBuilderApiTypes';
import {
  hasDynamicListChildren,
  isMultiSelectDynamicListType,
} from 'src/utils/solve/dynamicContextVariableUtils';

export const formatContextVariablesForInput = (
  contextVariables: ContextVariable[] | DynamicListOption[],
  value: string,
  prevCvName?: string,
) => {
  let newMessage = value;
  contextVariables.forEach(cv => {
    const cvName = prevCvName
      ? prevCvName + '.' + cv.context_variable_name
      : `$${cv.context_variable_name}`;

    // A multi-select dynamic list is referenceable only as a whole object, so
    // it behaves as a leaf here: recursing into its children would skip the
    // parent entirely and leave the inserted `$Name` as literal text.
    if (
      'configuration_fields' in cv &&
      hasDynamicListChildren(cv) &&
      !isMultiSelectDynamicListType(cv.context_variable_type)
    ) {
      if (!cv.configuration_fields?.dynamic_list_config?.context_variables) {
        throw new Error('Dynamic list config missing context variables');
      }
      newMessage = formatContextVariablesForInput(
        cv.configuration_fields?.dynamic_list_config?.context_variables,
        newMessage,
        cvName,
      );
      return;
    }

    if ('options' in cv && cv.options?.length) {
      newMessage = formatContextVariablesForInput(
        cv.options,
        newMessage,
        cvName,
      );
      return;
    }

    newMessage = newMessage.replaceAll(`{{${cv.context_variable_id}}}`, cvName);
  });
  return newMessage;
};
